import api from '.';
import logger from '../utils/logger';
import { Quote, QuoteRequestParams } from '../types/quotes';

export const getQuote = async (params: QuoteRequestParams): Promise<Quote> => {
  try {
    const { data } = await api.post('/rental-order-service/calculate_quote', params);
    return data;
  } catch (error) {
    logger('error', 'at getQuote while fetching quote', error);
    throw new Error('error at getQuote while fetching quote');
  }
};
